import { vm } from '@/main';

export const useNotify = () => {
    const notification = {
        group: 'default',
        type: '',
        title: '',
        text: '',
    };

    const assignNotification = (
        type: string,
        title: string,
        text: string,
        group = 'default',
    ) => {
        notification.type = type;
        notification.title = title;
        notification.text = text;
        notification.group = group;
    };

    const toast = (type = '', title = '', text) => {
        assignNotification(type, title, text);
        vm.$root.$notify(notification);
    };

    const successToast = (text: string, group = '') => {
        if (group === '') {
            group = 'default';
        }
        assignNotification('success', 'Success', text, group);
        vm.$root.$notify(notification);
    };

    const errorToast = (text: string, group = '') => {
        if (group === '') {
            group = 'default';
        }
        assignNotification('error', 'Error', text, group);
        vm.$root.$notify({
            ...notification,
            duration: 13000,
        });
    };

    const warnToast = (text: string, group = '') => {
        if (group === '') {
            group = 'default';
        }
        assignNotification('warn', 'Warning', text, group);
        vm.$root.$notify({
            ...notification,
            duration: 13000,
        });
    };

    return {
        toast,
        successToast,
        errorToast,
        warnToast,
    };
};
